
import "./Album.scss";   
import React, { useEffect } from 'react';

// Default light box   
import Lightbox from "yet-another-react-lightbox"; 
import "yet-another-react-lightbox/styles.css"; 
 
// Advanced light box
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css"; 

import { useState } from "react";

export interface IFigure {
  src          : string;
  width        : number;
  height       : number;
  title        : string; 
  description ?: string;
  gridLayout   : [ number, number, number, number ]; 
                // x     / y    / span x / span y;
}

interface IPropsAlbum {
  figures    : IFigure[]; 
  gridColNb ?: number;
  gridRowNb ?: number;
  onAlbumToggle ?: (isOpen: boolean) => void;
}

// Util function
function assert(cond : boolean, text : string = "Assertion failed") {
  if (! cond) {
    throw new Error(text);
  }
}

function parseGridSize(figures : IFigure[]) {    
  assert(figures.length > 0, "figures.length > 0");
  
  let maxCol = 0;
  let maxRow = 0; 

  for (const f of figures) {
    assert(f.gridLayout[0] >= 0, "f.gridLayout[0] >= 0");
    assert(f.gridLayout[1] >= 0, "f.gridLayout[1] >= 0");
    assert(f.gridLayout[2] >  0, "f.gridLayout[2] >= 0");
    assert(f.gridLayout[3] >  0, "f.gridLayout[3] >= 0");
 
    maxRow = Math.max(maxRow, f.gridLayout[0] + f.gridLayout[2]);
    maxCol = Math.max(maxCol, f.gridLayout[1] + f.gridLayout[3]); 
    
  }
  maxCol -= 1;
  maxRow -= 1;
  
  return { maxCol, maxRow };
}

// The image gallery component
export function Album({figures, gridColNb, gridRowNb, onAlbumToggle} : IPropsAlbum) {
  let [index, setIndex] = useState(-1); 
  
  useEffect(() => {
    onAlbumToggle?.(index >= 0);
  }, [index, onAlbumToggle]);

  if (gridColNb === undefined && gridRowNb === undefined) {
    ({maxCol : gridColNb, maxRow : gridRowNb} = parseGridSize(figures));
  }
  assert(gridColNb !== undefined && gridRowNb !== undefined, "gridColNb !== undefined && gridRowNb !== undefined"); 

  return (<> 
    <div className="album" 
    style={{
        gridTemplateColumns: "repeat("+gridColNb+", 1fr)",
        gridTemplateRows: "repeat("+gridRowNb+", 1fr)" 
      }}
    >
      {figures.map( (p, i) =>
        <figure key={i} onClick={() => setIndex(i)} style={{
          gridArea : `${p.gridLayout[0]} / ${p.gridLayout[1]} 
               / span ${p.gridLayout[2]} / span ${p.gridLayout[3]}`,
          aspectRatio : `${p.gridLayout[3]} / ${p.gridLayout[2]}` ,
          backgroundImage : "url("+p.src
            .replace("/img/", "/small/")
            .replace(/\.[^.]+$/, ".jpg")+")"
          }}> 
          <img src={p.src} alt={p.title} loading="lazy"/>
          <figcaption>{p.title}</figcaption>
        </figure>
      )}  
    </div>

    <Lightbox
      index={index}
      slides={figures}
      open={index >= 0}
      close={() => setIndex(-1)}
      plugins={[Captions, Fullscreen, Slideshow, Thumbnails, Video, Zoom]}
    />
  </>);
}
  